import React from "react";
import LocalSearchSidebar from "./LocalSearchSidebar";

function LocalSearchPage() {
  return (
    <div className="mx-auto w-[95vw] lg:w-[85vw] lg:py-[1vw] ">
      <LocalSearchSidebar />
    </div>
  );
}

export default LocalSearchPage;
